import { useEffect } from "react"; 
import { ANDROID_URL, IOS_URL } from "../helpers/api";

const AppDownload = () => {
  const appStoreUrl = IOS_URL;
  const playStoreUrl = ANDROID_URL;

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    window.location.href = isIOS ? appStoreUrl : playStoreUrl;
  }, []);

  return (
    <p>Chargement...</p>
  );
};

export default AppDownload;
